<template>
  <section>
    <h3>Liste den Geräten</h3>
    <div class="row">
      <div class="col-4">
        <input
          class="form-control me-2"
          type="search"
          placeholder="Search"
          aria-label="Search"
          v-model="search"
          id="search"
        />
        <hr />
        <ul ref="devices" class="list-group">
          <li
            type="button"
            v-for="(device, index) in listDevices"
            :key="index"
            class="list-group-item"
            @click="loadInfoDevice(device)"
          >
            {{ device.marker }}
            {{ device.series }}
            {{ device.name }}
          </li>
        </ul>
      </div>
      <div v-if="currentDeviceIs" class="col-8">
        <div class="card mb-3" style="max-width: 640px">
          <div class="row g-0">
            <div class="col-md-4">
              <img
                v-if="currentDeviceIs.thumbnail"
                :src="$store.state.config.endpoint + currentDeviceIs.thumbnail"
                :alt="currentDeviceIs.thumbnail"
                class="img-fluid rounded-start"
              />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-primary fw-bold">
                  {{ currentDeviceIs.name }}
                </h5>
                <div class="card-text">
                  <ul
                    v-if="servicesCurrentDeviceIs"
                    class="list-group list-group-flush"
                  >
                    <h5 class="mt-3">Reparaturarten:</h5>
                    <li
                      v-for="(device, index) in servicesCurrentDeviceIs"
                      :key="index"
                      class="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <a
                        type="button"
                        :href="('/#/cpanel/service/edit/'+ device.serviceId)"
                        class="btn btn-sm btn-outline-success d-inline-block me-2"
                        title="Service Bearbeiten">
                        <i class="fa-solid fa-sm fa-pen-to-square"></i>
                      </a>
                      <span class="d-inline-block">{{ device.title }}</span>
                      <span v-if="device.state == 1" class="text-muted small">Verfügbar</span>
                      <span v-else class="text-muted small">Nicht verfügbar</span>
                      <span class="badge bg-primary rounded-pill">{{ device.price }}€</span>
                    </li>
                  </ul>
                  <div v-else>Keine verfügbaren Reparaturarten</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Dashbaord",

  data() {
    return {
      currentDeviceIs: undefined,
      servicesCurrentDeviceIs: undefined,
      devices: undefined,
      listDevices: undefined,
      search: "",
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadDashDevives();
    });
  },

  watch: {
    search(val) {
      this.listDevices = [];
      this.devices.map((element) => {
        if (
          element.marker.toUpperCase().indexOf(val.toUpperCase()) > -1 ||
          element.series.toUpperCase().indexOf(val.toUpperCase()) > -1 ||
          element.name.toUpperCase().indexOf(val.toUpperCase()) > -1
        ) {
          this.listDevices.push(element);
        }
      });
    },
  },

  methods: {
    loadDashDevives() {
      this.$store.state.modules.api
        .loadDashDevives()
        .then((resp) => {
          console.log(resp);
          if (resp.status == 200) {
            this.devices = resp.data.units;
            this.listDevices = this.devices;
          }
          this.$store.state.utils.loaded = true;
        })
        .catch((err) => {
          this.$store.state.utils.loaded = true;
        });
    },

    loadInfoDevice(device) {
      console.log(device.uid);
      this.currentDeviceIs = device;
      this.$store.state.modules.api
        .loadInfoDevice(device.uid)
        .then((resp) => {
          console.log(resp);
          if (resp.status == 200) {
            this.servicesCurrentDeviceIs = resp.data.units;
          } else {
            this.servicesCurrentDeviceIs = undefined;
          }
          this.$store.state.utils.loaded = true;
        })
        .catch((err) => {
          this.$store.state.utils.loaded = true;
        });
    },
  },
};
</script>
